<template>
  <v-container class="py-0">
    <v-row>
      <v-col cols="4" class="px-2 pt-1 pb-0 filters-container">
        <v-select
          v-model="selectedCategory"
          :items="categories"
          item-text="text"
          item-value="value"
          label="Category"
          hide-details
          multiple
          clearable
          class="py-0 filters-label"
          @change="handleChangeFilter"
        >
          <template v-slot:selection="{ index }">
            <span v-if="index === 0">
              {{ selectedCategory.length }} selected
            </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="4" class="px-2 pt-1 pb-0">
        <v-select
          v-model="selectedSeverity"
          :items="severities"
          item-text="text"
          item-value="value"
          label="Potential Severity"
          hide-details
          multiple
          clearable
          class="py-0 filters-label"
          @change="handleChangeFilter"
        >
          <template v-slot:selection="{ index }">
            <span v-if="index === 0">
              {{ selectedSeverity.length }} selected
            </span>
          </template>
        </v-select>
      </v-col>
      <v-col cols="4" class="px-2 pt-1 pb-0">
        <v-select
          v-model="selectedImpactType"
          :items="impactTypes"
          item-text="text"
          item-value="value"
          label="Impact Type"
          hide-details
          multiple
          clearable
          class="py-0 filters-label"
          @change="handleChangeFilter"
        >
          <template v-slot:selection="{ index }">
            <span v-if="index === 0">
              {{ selectedImpactType.length }} selected
            </span>
          </template>
        </v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  getCalendarEventsCategories,
  getCalendarEventsImpactTypes,
} from "@/services/calendarEvents/calendarEvents.service";

const EMITTED_ACTIONS = {
  CHANGE_FILTERS: "change-filters",
};

export default {
  name: "CalendarEventsFilters",
  data() {
    return {
      selectedCategory: null,
      categories: [],
      selectedSeverity: null,
      severities: [
        { text: "Low", value: "low" },
        { text: "Medium", value: "medium" },
        { text: "High", value: "high" },
      ],
      selectedImpactType: null,
      impactTypes: [],
    };
  },
  async mounted() {
    this.categories = await getCalendarEventsCategories();
    this.impactTypes = await getCalendarEventsImpactTypes();
  },
  methods: {
    handleChangeFilter() {
      const selectedFilters = {
        selectedCategory: this.selectedCategory,
        selectedSeverity: this.selectedSeverity,
        selectedImpactType: this.selectedImpactType,
      };
      this.$emit(EMITTED_ACTIONS.CHANGE_FILTERS, selectedFilters);
    },
  },
  beforeDestroy() {
    this.selectedCategory = null;
    this.categories = [];
    this.selectedSeverity = null;
    this.severities = [];
    this.selectedImpactType = null;
    this.impactTypes = [];
  },
};
</script>

<style scoped>
.filters-label .v-label,
.filters-label .v-select__selections {
  font-size: 0.75rem;
}
</style>
